import { Deserializable } from "../deserializable";

export class UsersSearchRequest implements Deserializable {

    public searchTerm: string = "";
    public entityType: number;
    public entityId: number;
    public orderBy: string =  "Full Name";
    public orderDirection: string =  "ASC";

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
      }
}
